"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentsContainer_de_de = void 0;
function componentsContainer_de_de() {
    return {
        "components.container.direction.vertical": "Vertikal",
        "components.container.direction.horizontal": "Horizontal",
        "components.container.flexattributes.flex-start": "Start",
        "components.container.flexattributes.center": "Center",
        "components.container.flexattributes.flex-end": "Ende",
        "components.container.flexattributes.stretch": "Ausdehnen",
        "components.container.flexattributes.normal": "Normal",
        "components.container.flexattributes.space-between": "Mit Platz dazwischen",
        "components.container.flexattributes.space-around": "Mit Platz außen herum",
        "components.container.flexattributes.space-evenly": "Platz gleichmäßig verteilt"
    };
}
exports.componentsContainer_de_de = componentsContainer_de_de;
